import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Pencil, Plus, Trash } from "@phosphor-icons/react/dist/ssr";

const tableConfig: FinalTableConfig = {
      index: null,
      actions: [
        {
          name: TableAction.CREATE, 
          label: 'create',
          showLabel: true,
          allowed: true,
          show: true,
          action: null,
          icon: <Plus size={20} />,
        },        

      ],
      rowActions: [
        {
          name: RowAction.EDIT, 
          label: 'edit',
          icon: <Pencil size={20} />,
          allowed: true,
          show: true,
          action: (element: any) => {
            console.log('edit', element);
          }
        },
        {
          name: RowAction.DELETE, 
          label: 'delete',
          icon: <Trash size={20} />,
          allowed: true,
          show: true,
          action: (element: any) => { 
            console.log('delete', element);
          }              
        }      
      ],
      rowConfiguration: {
        class: (element: any) => {
          return '';
        }
      },
      columns: [
        {
          name: 'id',
          label: '#',
          key: 'id',
          type: 'number',
          show: true,
          allowOrder: true,
        },
        {
          name: 'code',
          label: 'code',
          key: 'code',
          type: 'string',
          show: true,
          allowOrder: true,
        },
        {
            name: 'status',
            label: 'status',
            key: 'status.value',
            type: 'string',
            show: true,
            allowOrder: true,
          },
        // {
        //   name: 'task',
        //   label: 'task',
        //   key: 'task',
        //   type: 'url',
        //   show: true,
        //   allowOrder: true,
        // },
        // {
        //   name: 'date',
        //   label: 'date',
        //   key: 'date',
        //   type: 'date',
        //   show: true,
        //   allowOrder: true,
        // },
        // {
        //   name: 'customer',
        //   label: 'customer',
        //   key: 'customer.name',
        //   type: 'string',
        //   show: true,
        //   allowOrder: true,
        // },
        // {
        //   name: 'status',
        //   label: 'status',
        //   key: 'status.value',
        //   type: 'string',
        //   show: true,
        //   allowOrder: true,
        // },
  
      ],
      pagination: {
        enabled: true,
        back: true
    }
}
const getConfig: any = (functions: any) => {
    const { getFunction, indexFunction, initializeFunction, prepareRemoveFunction } = functions;
    tableConfig.actions[0].action = () => initializeFunction();
    // tableConfig.actions[1].action = () => indexFunction();
    tableConfig.index = () => indexFunction();
    tableConfig.rowActions[0].action = (id: any) => getFunction(id);
    tableConfig.rowActions[1].action = (id: any) => prepareRemoveFunction(id);
    return tableConfig;
}
export default getConfig;